import { render } from "./salesman_page_setup.vue?vue&type=template&id=2e740874&scoped=true"
import script from "./salesman_page_setup.vue?vue&type=script&lang=js"
export * from "./salesman_page_setup.vue?vue&type=script&lang=js"

import "./salesman_page_setup.vue?vue&type=style&index=0&id=2e740874&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e740874"]])

export default __exports__